<div class="container">
  <div class="callout">
    <h2>Your Digital Certificate Has Expired</h2>
    <div class="message-container">
      <p>
        If you have already purchased a digital certificate, please click the Update Certificate button to upload it to Clear Sign. Once updated, refresh this page to proceed with the closing.
      </p>
      <p>
        If you have not yet purchased a certificate, please cancel this closing and obtain a new certificate through Identrust before continuing.
      </p>
    </div>
    <div class="image-container">
      <img src="../../../../../assets/images/alarm.svg" alt="" />
    </div>
    <div class="button-container">
      <app-button
        type="primary"
        (buttonClick)="updateCommission()"
        [dataTestId]="'expired-cert-update'"
      >
        Update Certificate
      </app-button>
      <app-button
        type="tertiary"
        (buttonClick)="cancelSigning()"
        [dataTestId]="'expired-cert-cancel-signing'"
      >
        Cancel Signing
      </app-button>
    </div>
  </div>
</div>
